const Whymcm =()=>
{
    return(
    <>
    <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10 text-center">
                    <h1 className="display-3 text-white animated slideInDown">Why Choose Mysore City Minority College</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center">
  <li className="">
    <a className="text-white" href="">Home</a>
  </li>

  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  </li>

  <li className=" active text-white" aria-current="page">
    Why Us
  </li>
</ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    <div className="container-xxl py-5">
        <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3"></h6>
                <h1 className="mb-5">Advantages at Mysore City Minority College</h1>
            </div>
            
            <div className="row g-4">
                {/* <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="card why-choose-card border-0 shadow h-100 p-4">
                        <div className="feature-icon bg-primary text-white rounded-circle">
                            <i className="fas fa-user-tie fa-2x"></i>
                        </div>
                        <h4 className="mb-3">Expert Instructors</h4>
                        <p className="mb-3">Learn from industry professionals and academic experts with real-world experience. Our instructors are not just teachers; they're practitioners who bring current industry insights to every lesson.</p>
                    </div>
                </div> */}
                
                {/* <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                    <div className="card why-choose-card border-0 shadow h-100 p-4">
                        <div className="feature-icon bg-primary text-white rounded-circle">
                            <i className="fas fa-laptop-code fa-2x"></i>
                        </div>
                        <h4 className="mb-3">Interactive Learning</h4>
                        <p className="mb-3">Our platform uses cutting-edge technology to create engaging, interactive learning experiences. With virtual labs, simulations, and collaborative projects, you'll gain practical skills you can apply immediately.</p>
                    </div>
                </div> */}
                
                {/* <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="card why-choose-card border-0 shadow h-100 p-4">
                        <div className="feature-icon bg-primary text-white rounded-circle">
                            <i className="fas fa-calendar-alt fa-2x"></i>
                        </div>
                        <h4 className="mb-3">Flexible Schedule</h4>
                        <p className="mb-3">Learn at your own pace, anytime, anywhere. Access course materials 24/7 and choose between self-paced or instructor-led options to fit your lifestyle and commitments.</p>
                    </div>
                </div> */}
                
                {/* <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="card why-choose-card border-0 shadow h-100 p-4">
                        <div className="feature-icon bg-primary text-white rounded-circle">
                            <i className="fas fa-certificate fa-2x"></i>
                        </div>
                        <h4 className="mb-3">Industry-Recognized Certifications</h4>
                        <p className="mb-3">Graduate with certifications that employers value. Our courses are designed in collaboration with industry leaders to ensure you gain relevant, up-to-date skills.</p>
                    </div>
                </div> */}
                
                {/* <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                    <div className="card why-choose-card border-0 shadow h-100 p-4">
                        <div className="feature-icon bg-primary text-white rounded-circle">
                            <i className="fas fa-hands-helping fa-2x"></i>
                        </div>
                        <h4 className="mb-3">Career Support</h4>
                        <p className="mb-3">Get more than just education. Our career services include resume reviews, interview preparation, and job placement assistance to help you advance your career.</p>
                    </div>
                </div> */}
                
                {/* <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="card why-choose-card border-0 shadow h-100 p-4">
                        <div className="feature-icon bg-primary text-white rounded-circle">
                            <i className="fas fa-users fa-2x"></i>
                        </div>
                        <h4 className="mb-3">Vibrant Community</h4>
                        <p className="mb-3">Join a global network of learners, alumni, and professionals. Collaborate on projects, participate in discussions, and build connections that last beyond your courses.</p>
                    </div>
                </div> */}
                <div className="col-lg-12 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="card why-choose-card border-0 shadow h-100 p-4">
                        
                        <p className="mb-3">Detailed class room study by group of well experienced lecturers for all subjects. Soft Skill Training as a part of career development programme to build competency in communication skills such as spoken, written and presentation skills. Industry Visits/Projects and Field studies to enable the students to relate the learnt concepts. The students shall be taken for Industrial Visits every year. The projects and field studies are advised to the students for the syllabus point of view. Excellent coaching for CA is provided for all students at campus. The classes are managed by well Known professional from Bangalore. Interested students are assisted to join for higher studies. Sports and Cultural activities conducted at College level and students are encouraged to participate the sports and cultural activities at University level also. Excellent training will be provided by efficient Trainers.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-xxl py-5">
        <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3"></h6>
                <h1 className="mb-5">Placement</h1>
            </div>
            <div className="col-lg-12 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="card why-choose-card border-0 shadow h-100 p-4">
                        
                        <p className="mb-3" ><center>All students will be assisted to get placement through campus selection. All facilities will be provided to take up job in India or Abroad.</center></p>
                    </div>
                </div>
        </div>
    </div>
    </>
    )
}
export default Whymcm;